import { render } from "./TriageBadgeStatus.vue?vue&type=template&id=dd9e705c"
import script from "./TriageBadgeStatus.vue?vue&type=script&lang=js"
export * from "./TriageBadgeStatus.vue?vue&type=script&lang=js"

import "./TriageBadgeStatus.vue?vue&type=style&index=0&id=dd9e705c&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__